import React from "react";

import { AllocationUnit } from "@common/allocationUnit";
import { toFixed } from "../utils";
import { Props } from "./types";
import styles from "./styles.scss";

function TasksProgression(props: Props) {
  return (
    <div className={styles.tasksProgression}>
      <h3 className={styles.title}>
        <span style={{ backgroundColor: props.color }} />
        {props.title}
      </h3>
      <div className={styles.group}>
        <h4 className={styles.percentage} style={{ color: props.color }}>
          {toFixed(props.percentage)}%
        </h4>
        <p className={styles.hours}>
          {toFixed(props.hours)}
          <AllocationUnit />
        </p>
      </div>
      <div className={styles.bar} style={{ backgroundColor: props.color }} />
    </div>
  );
}

export { TasksProgression };
